module.exports = __webpack_public_path__ + "img/material.b055fbe0.jpg";